import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { FeatureGate } from '../firm/feature-gate';
import { IntakeCasePage } from '../firm/intake-case-page';

export const Route = createFileRoute('/intakes/$caseId')({
  // Back from the second factor, the form that asked for it opens again (`useStepUpForm`).
  validateSearch: z.object({
    capture: z
      .enum(['identification', 'prior-identification', 'remote-identification', 'risk'])
      .optional()
      .catch(undefined),
  }),
  component: IntakeCase,
});

/** One intake of a mandate (ADR-025), with CHECK-POINT. */
function IntakeCase() {
  const { caseId } = Route.useParams();
  return (
    <FeatureGate feature="check-point">
      <IntakeCasePage caseId={caseId} />
    </FeatureGate>
  );
}
